import type {
    ResearchQuestionStatus,
    ResearchRunStatus,
} from "models/ResearchFindings/ResearchFindings";

/** e.g. "Jul 1, 2026". */
export function formatRunDate(iso?: string): string {
    if (!iso) return "";
    return new Date(iso).toLocaleDateString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
}

/** e.g. "9:00 AM". */
export function formatRunTime(iso?: string): string {
    if (!iso) return "";
    return new Date(iso).toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });
}

/** e.g. "Jul 1, 2026, 9:00 AM". */
export function formatDateTime(iso?: string): string {
    if (!iso) return "";
    return new Date(iso).toLocaleString(undefined, {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
    });
}

type MuiColor = "default" | "info" | "success" | "warning" | "error";

export function runStatusColor(status?: ResearchRunStatus): MuiColor {
    switch (status) {
        case "Completed":
            return "success";
        case "Running":
            return "info";
        case "Bookmarked":
            return "warning";
        default:
            return "default";
    }
}

export function questionStatusColor(status: ResearchQuestionStatus): MuiColor {
    switch (status) {
        case "Delivered":
            return "success";
        case "Researched":
            return "info";
        case "Rejected":
            return "error";
        case "Generated":
        default:
            return "default";
    }
}

/** Percentage a statistic represents (count / denominator), rounded. */
export function statisticPercent(count: number, denominator: number): number {
    if (!denominator) return 0;
    return Math.round((count / denominator) * 100);
}
